import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { dataMetrics } from '@/mocks/smart-restaurant';

export default function DataValue() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-foreground-950">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="数据价值"
          title="让关键经营数据，进入同一视野"
          subtitle="从营收、订单、库存、履约、客户、权益到结算，管理者可以按组织、门店、时间和业务口径查看结果，定位异常并复盘改进。"
          dark
        />

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {dataMetrics.map((metric, idx) => (
            <Reveal key={metric.id} delay={idx * 50}>
              <div className="p-5 rounded-lg bg-background-50/5 border border-background-50/10">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{metric.label}</span>
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-secondary-500/15 text-secondary-300">
                    <i className={`${metric.icon} text-sm`}></i>
                  </div>
                </div>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className="font-heading font-bold text-background-50 text-2xl md:text-3xl">
                    {metric.value}
                  </span>
                  <span className="text-xs text-foreground-400">{metric.unit}</span>
                </div>
                <div className="mt-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-background-50/10 text-[10px] text-foreground-300">
                  {metric.status}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-400">
          以上指标为界面示意，数值以真实项目运营数据为准，接入后呈现。
        </p>
      </div>
    </section>
  );
}